// extracted by mini-css-extract-plugin
export default {"unavailable":"u5T0l","text":"h32aa"};